// import JsPDF from 'jspdf'
import config from '../config.js';
import { domToPng } from 'modern-screenshot';

const TYPES = config.pageSizeType;

const _addWatermark = (canvas, text) => {
    // 倾斜45度
    let ctx = canvas.getContext('2d');
    ctx.save();
    ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // 加粗
    ctx.font = 'bold 14px Microsoft JhengHei';
    ctx.rotate(-45 * Math.PI / 180);
    // 水印
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
    ctx.restore(); 
    return canvas;
}

function inserBreakFlagFn(scrollContainer, tplBox, pageSize) {
    // 获取模板容器的位置信息
    const tplBoxRect = tplBox.getBoundingClientRect();
    // 递归遍历所有子节点
    const nodes = [];
    const walker = document.createTreeWalker(
      tplBox,
      NodeFilter.SHOW_ELEMENT,
      { acceptNode: () => NodeFilter.FILTER_ACCEPT }
    );
    let currentNode;
    while ((currentNode = walker.nextNode())) {
      nodes.push(currentNode);
    }
    // 按垂直位置排序节点
    nodes.sort((a, b) => a.offsetTop - b.offsetTop);
    // 遍历处理每个节点
    nodes.forEach(node => {
      // 计算节点相对于模板容器的位置
      const nodeRect = node.getBoundingClientRect();
      const relativeTop = nodeRect.top - tplBoxRect.top;
      // 检查是否需要插入分页符
      if (relativeTop > pageSize) {
        const pageNumber = Math.floor(relativeTop / pageSize);
        // 避免重复插入（检查前一个兄弟节点）
        let prevSibling = node.previousElementSibling;
        while (prevSibling && !prevSibling.classList.contains('page-break')) {
          prevSibling = prevSibling.previousElementSibling;
        }
        if (!prevSibling || !prevSibling.classList.contains('page-break')) {
          const pageBreak = document.createElement('div');
          pageBreak.className = 'page-break';
          pageBreak.style.pageBreakBefore = 'always'; // CSS分页属性
          node.parentNode.insertBefore(pageBreak, node);
        }
      }
    });
  }

  
const html2pdfOptions = {
    margin: [0, 0, 0, 0], // 边距
    filename: 'default.pdf',
    image: { type: "jpeg", quality: 0.85 },
    unit: "mm",
    html2canvas: {
        scale: 1.8,
        dpi: getDPI(),
        useCORS: true,
        logging: false // 开启日志查看渲染过程
    },
    jsPDF: {
        unit: "mm",
        format: "a4", // 改为A4尺寸
        orientation: "portrait",
    },
    // 分页
    pagebreak: {
        mode: ["css"],
        before: ".page-break" // 指定分页标识类名（可选）
    },
};

const html2pdfOptions2 = {
    margin: [0,0, 0, 0], // 边距
    filename: 'default.pdf',
    image: { type: "jpeg", quality: 0.5 },
    unit: "mm",
    html2canvas: {
        scale: 1.3,
        dpi: getDPI(),
        useCORS: true,
        logging: false // 开启日志查看渲染过程
    },
    jsPDF: {
        unit: "mm",
        format: "a4", // 改为A4尺寸
        orientation: "portrait",
    },
    // 分页
    pagebreak: {
        mode: ["css"],
        before: ".page-break" // 指定分页标识类名（可选）
    },
};
 
export const previeHTML2PDFFn = async (elementId, filename = '我的简历.pdf') => {
    return new Promise(async (resolve, reject) => {
        if (!elementId) {
            reject('elementId is required')
            return;
        };
        const warningLines = document.querySelectorAll('.fenye-wrap') || [];
        console.log('warningLines num:', warningLines.length);
        if (warningLines.length >= 5 ) {
          reject('请检查分页设置，避免分页符过多');
        }
        if (window.html2pdf) {
          const element = document.getElementById(elementId);
          // 定义分页阈值（根据你的需求调整这些值）
          const pageSize = element.dataset.containerMinHeightPx || 842; // 单位：像素，示例值
          const opt = {
            ...html2pdfOptions2,
            filename,
          };
          // 生成PDF并获取Base64
          const pdfData = await window.html2pdf().set(opt).from(element).output('datauristring');
          resolve(pdfData);
        } else {
           reject('html2pdf is not defined');
        }  
    })
}

const saveHTML2PDFFn = (elementId, filename = Date.now() + '.pdf', callback = (...args) => {}) => {
    try {
          if (!elementId) {
              callback && callback(false);
              return;
          };
          if (window.html2pdf) {
            // const scrollContainer = document.getElementById('scroll-page-box');
            const element = document.getElementById(elementId);
            // 定义分页阈值（根据你的需求调整这些值）
            const pageSize = element.dataset.containerMinHeightPx || 842; // 单位：像素，示例值
            // 动态插入分页符
            // inserBreakFlagFn(scrollContainer, element, pageSize);
              const opt = {
                ...html2pdfOptions,
                filename,
              };
              setTimeout(() => {
                window.html2pdf().set(opt).from(element).save().then(() => {
                  callback && callback(true);
                }).catch((error) => {
                  console.log('saveHTML2PDFFn error:', error);
                  callback && callback(false, error);
                });
              }, 16);
          } else {
              callback && callback(false);
          }
    } catch (error) {
          console.log('savePPT2PDFFn error:', error);
          callback && callback(false);
    }
}

// html2Pdf.js
class Html2Pdf {
    constructor(option) {
        this.title = "";                // 文件标题
        this.noClass = ["no2canvas"];   // 需要忽略的class名
        this.type = "a4";               // 生成类型默认为A4纸张
        this.el;                        // 生成的目标元素
        this.beforeFn;                  // 生成图像前可执行
        this.afterFn;
        this.elId;                 // 生成图像后可执行
        Object.assign(this, option);
        return this;
    }
    async start(downloadtype = 'pdf') {
        const { title, type, el, beforeFn, afterFn, noClass, elId } = this;
        const [w, h] = TYPES[type];
        if (!el) throw new Error("Missing target element!")
        beforeFn && await beforeFn.call(this);
        if (downloadtype == 'image') {
            domToPng(el, {
                width: el.offsetWidth,
                height: el.offsetHeight,
                backgroundColor: '#fff',
                scale: 2,
            })
            .then(async function (dataUrl) {
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = (title ? title : ('我的简历_' + Date.now())) + '.png'; // 设置下载的文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                afterFn && await afterFn.call(this);
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
        };
        if (downloadtype != 'pdf') {
            return;
        }
        // 生成PDF
        // const {width,height} = canvas
        // let pageHeight = width / w * h;
        // let leftHeight = height;
        // let position = 0;
        // let imgHeight = w / width * height;
        // let PDF = new JsPDF('', 'pt', type);
        // if (leftHeight < pageHeight) {
        //     PDF.addImage(dataURL, 'JPEG', 0, 0, w, imgHeight)
        // } else {
        //     while (leftHeight > 0) {
        //         PDF.addImage(dataURL, 'JPEG', 0, position, w, imgHeight);
        //         leftHeight -= pageHeight;
        //         position -= h;
        //         if (leftHeight > 0) PDF.addPage()
        //     }
        // }
        // PDF.save(title + '.pdf')
        saveHTML2PDFFn(elId, (title || '我的简历'), async (status) => {
            afterFn && await afterFn.call(this);
        });
    }
}

// function calculateA4Pixels(dpi) {
//     const mmToInch = 1 / 25.4;
//     const widthInch = 210 * mmToInch;
//     const heightInch = 297 * mmToInch;
//     return {
//         width: Math.round(widthInch * dpi),
//         height: Math.round(heightInch * dpi)
//     };
// }

// function getDPI() {
//     var tempDiv = document.createElement("div");
//     tempDiv.style.width = "1in";
//     tempDiv.style.visibility = "hidden";
//     document.body.appendChild(tempDiv);
//     var dpi = tempDiv.offsetWidth;
//     document.body.removeChild(tempDiv);
//     return dpi;
// }

// function mmToPixel(mm, dpi) {
//     // 1 inch = 25.4 mm
//     var inches = mm / 25.4;
//     var pixels = inches * dpi;
//     return Math.round(pixels);
// }

// function a4SizeInPixels() {
//     var dpi = getDPI();
//     var width_mm = 210; // A4纸宽度，单位：毫米
//     var height_mm = 297; // A4纸高度，单位：毫米
//     var width_px = mmToPixel(width_mm, dpi);
//     var height_px = mmToPixel(height_mm, dpi);
//     return { width: width_px, height: height_px };
// }

// export const getElementHeight = function(elementWidth) {
//     // const dpi = getScreenDpi();
//     // const a4Pixels = calculateA4Pixels(dpi);
//     // console.log("a4Pixels===>", a4Pixels, dpi, elementWidth, a4SizeInPixels(),  mmToPixel(6, getDPI()), mmToPixel(297 - 6, getDPI()));
//     // return Math.round((elementWidth / a4Pixels.width) * a4Pixels.height);
//     // return a4SizeInPixels().height - mmToPixel(2, getDPI());
//     return a4SizeInPixels().height - 2;
// }

// export const getElementWidth = function(elementWidth) {
//     return a4SizeInPixels().width;
// }
// 恢复为返回 CSS px / inch 的 getDPI（更稳健的实现，缓存，使用 getBoundingClientRect）
// 注意：这个版本与原来语义一致（不乘 devicePixelRatio），可直接替换原文件对应部分

var _cachedCssPpi = null;

function _createMeasurementDiv() {
  const div = document.createElement("div");
  div.style.width = "1in";
  div.style.height = "1in";
  div.style.position = "absolute";
  div.style.left = "-10000px";
  div.style.top = "-10000px";
  div.style.padding = "0";
  div.style.margin = "0";
  div.style.border = "0";
  div.style.boxSizing = "content-box";
  div.style.visibility = "hidden";
  return div;
}

/**
 * 返回 CSS 像素 每 英寸（css px / in）
 * 说明：多数浏览器将 1in 映射为 96 CSS px，但保留测量以处理缩放或特殊环境
 */
function getDPI() {
  if (_cachedCssPpi != null) return _cachedCssPpi;

  if (typeof document === "undefined") {
    _cachedCssPpi = 96;
    return _cachedCssPpi;
  }

  const parent = document.body || document.documentElement;
  const div = _createMeasurementDiv();
  parent.appendChild(div);

  // 使用 getBoundingClientRect 获取浮点数宽度（比 offsetWidth 更精确）
  const rect = div.getBoundingClientRect();
  const cssPxPerInch = (rect && rect.width) ? rect.width : (div.offsetWidth || 96);

  div.parentNode.removeChild(div);

  _cachedCssPpi = cssPxPerInch;
  return _cachedCssPpi;
}

function mmToPixel(mm, dpi) {
  var inches = mm / 25.4;
  var pixels = inches * dpi;
  return Math.round(pixels);
}

function calculateA4Pixels(dpi) {
    const mmToInch = 1 / 25.4;
    const widthInch = 210 * mmToInch;
    const heightInch = 297 * mmToInch;
    return {
        width: Math.round(widthInch * dpi),
        height: Math.round(heightInch * dpi)
    };
}

function a4SizeInPixels() {
    var dpi = getDPI(); // CSS px/in
    var width_mm = 210; // A4 宽度，单位：毫米
    var height_mm = 297; // A4 纸高度，单位：毫米
    var width_px = mmToPixel(width_mm, dpi);
    var height_px = mmToPixel(height_mm, dpi);
    return { width: width_px, height: height_px };
}

export const getElementHeight = function(elementWidth) {
    // 恢复为（你之前的实现）返回 A4 高度 - 2（像素），如果你不需要减小留白可以去掉 -2
    return a4SizeInPixels().height - 4;
}

export const getElementWidth = function(elementWidth) {
    return a4SizeInPixels().width;
}

export default Html2Pdf;